/**
 * ADA / WCAG accessibility enhancements for Pladra
 */
(function () {
  'use strict';

  var strings = window.theme && window.theme.strings ? window.theme.strings : {};

  function setDialogState(dialog, isOpen) {
    if (!dialog) return;
    dialog.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    var main = document.getElementById('MainContent');
    if (main) {
      main.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    }
  }

  function initDialogs() {
    ['NavDrawer', 'CartDrawer'].forEach(function (id) {
      var drawer = document.getElementById(id);
      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
      }
    });

    document.querySelectorAll('.modal').forEach(function (modal) {
      modal.setAttribute('aria-hidden', 'true');
      if (!modal.getAttribute('role')) {
        modal.setAttribute('role', 'dialog');
      }
      if (!modal.hasAttribute('aria-modal')) {
        modal.setAttribute('aria-modal', 'true');
      }
    });

    document.addEventListener('drawerOpen', function (e) {
      var id = e.type === 'drawerOpen' && e.detail ? e.detail : null;
      document.querySelectorAll('.drawer.drawer--is-open').forEach(function (drawer) {
        setDialogState(drawer, true);
      });
    });

    document.addEventListener('drawerOpen.NavDrawer', function () {
      setDialogState(document.getElementById('NavDrawer'), true);
    });
    document.addEventListener('drawerOpen.CartDrawer', function () {
      setDialogState(document.getElementById('CartDrawer'), true);
    });

    document.addEventListener('modalOpen', function () {
      document.querySelectorAll('.modal.modal--is-active').forEach(function (modal) {
        setDialogState(modal, true);
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.js-drawer-close')) {
        var drawer = e.target.closest('.drawer');
        if (drawer) setDialogState(drawer, false);
      }
      if (e.target.closest('.js-modal-close')) {
        var modal = e.target.closest('.modal');
        if (modal) setDialogState(modal, false);
      }
    });
  }

  function updateCartLabel(count) {
    var label = strings.cartLabel || 'Cart';
    var itemsLabel = strings.itemsInCart || 'items';
    var text = count > 0 ? label + ', ' + count + ' ' + itemsLabel : label;
    document.querySelectorAll('.js-drawer-open-cart').forEach(function (el) {
      el.setAttribute('aria-label', text);
    });
  }

  function initCartAccessibility() {
    var bubbleNum = document.querySelector('.cart-link__bubble-num');
    var count = bubbleNum ? parseInt(bubbleNum.textContent, 10) || 0 : 0;
    updateCartLabel(count);

    document.addEventListener('cart:updated', function (e) {
      var itemCount = e.detail && e.detail.cart ? e.detail.cart.item_count : 0;
      updateCartLabel(itemCount);
    });
  }

  function enhanceGenericLinks() {
    var genericTexts = ['learn more', 'shop now', 'shop men\'s', 'shop women\'s', 'get more info'];
    document.querySelectorAll('a').forEach(function (link) {
      var text = (link.textContent || '').trim().toLowerCase();
      if (!genericTexts.includes(text)) return;
      if (link.getAttribute('aria-label')) return;

      var heading = link.closest('section, .hero, .grid__item, .promo-grid__container');
      if (!heading) return;
      var context = heading.querySelector('h1, h2, h3, .hero__title, .grid-product__title');
      if (context) {
        var contextText = context.textContent.trim();
        if (contextText) {
          link.setAttribute('aria-label', text.charAt(0).toUpperCase() + text.slice(1) + ': ' + contextText);
        }
      }
    });
  }

  function initFormStatusRegions() {
    document.querySelectorAll('form').forEach(function (form) {
      if (form.querySelector('[role="alert"]')) return;
      var status = document.createElement('div');
      status.setAttribute('role', 'alert');
      status.setAttribute('aria-live', 'polite');
      status.className = 'visually-hidden';
      status.id = form.id ? form.id + '-status' : 'form-status-' + Math.random().toString(36).slice(2);
      form.insertBefore(status, form.firstChild);

      var observer = new MutationObserver(function () {
        var note = form.querySelector('.note--success, .errors, .form-error, .note--error');
        if (note && note.textContent.trim()) {
          status.textContent = note.textContent.trim();
        }
      });
      observer.observe(form, { childList: true, subtree: true, characterData: true });
    });
  }

  function initFlickityAccessibility() {
    document.querySelectorAll('.flickity-enabled').forEach(function (carousel) {
      if (carousel.getAttribute('role')) return;
      carousel.setAttribute('role', 'region');
      if (!carousel.getAttribute('aria-label')) {
        carousel.setAttribute('aria-label', strings.carouselLabel || 'Carousel');
      }
    });
  }

  function initVideos() {
    document.querySelectorAll('.product__video, .product-video-mp4-sound').forEach(function (video) {
      if (!video.getAttribute('aria-label')) {
        video.setAttribute('aria-label', strings.productVideo || 'Product video');
      }
    });
  }

  function initReducedMotion() {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.documentElement.setAttribute('data-disable-animations', 'true');
    document.querySelectorAll('[data-aos]').forEach(function (el) {
      el.removeAttribute('data-aos');
    });
  }

  function patchBoostPFS() {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      document.querySelectorAll('.boost-pfs-filter-option-title, .boost-pfs-search-suggestion-item').forEach(function (el) {
        if (!el.getAttribute('tabindex') && el.tagName !== 'A' && el.tagName !== 'BUTTON') {
          el.setAttribute('tabindex', '0');
        }
      });
      if (attempts > 20) clearInterval(interval);
    }, 500);
  }

  function init() {
    initDialogs();
    initCartAccessibility();
    enhanceGenericLinks();
    initFormStatusRegions();
    initFlickityAccessibility();
    initVideos();
    initReducedMotion();
    patchBoostPFS();

    document.addEventListener('shopify:section:load', function () {
      enhanceGenericLinks();
      initFlickityAccessibility();
      initVideos();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
